// Central API configuration.
// The base URL is injected at build time via REACT_APP_API_BASE_URL
// (see .env.development for local MAMP and .env.production for the server).
const API_BASE_URL = (
  process.env.REACT_APP_API_BASE_URL || "http://localhost/juntos-api"
).replace(/\/+$/, "");

export const AuthApi = `${API_BASE_URL}/auth.php`;
export const GameApi = `${API_BASE_URL}/game.php`;

export default API_BASE_URL;

